const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaODataSelectCtrl = function($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.entityIdentifier = vm.settings.entityIdentifier || "Id";
  vm.includeDisabled = vm.settings.includeDisabled === undefined ? true : vm.settings.includeDisabled;
  vm.filterUsingEnabled = vm.settings.filterUsingEnabled || false;
  vm.refreshData = refreshData;
  vm.isMultiSelect = vm.settings.isMultiSelect || false;
  vm.queryOption = vm.settings.queryOption || "filter";
  vm.selectProperty = vm.settings.selectProperty || "";

  vm.inputTitle = vm.settings.inputTitle || "Name";
  vm.selectChoiceName = vm.settings.selectChoiceName || "Title";
  vm.getChoiceValue = getChoiceValue;

  vm.includeOptions = vm.settings.includeOptions;
  vm.includeOptionsPropertyToSave = vm.settings.includeOptionsPropertyToSave;
  vm.dataSelectPropertyToCheck = vm.settings.dataSelectPropertyToCheck;

  vm.additionalFilters = vm.settings.additionalFilters || [];
  vm.additionalOptions = vm.settings.additionalOptions || [];
  vm.showOnlySelectedField = vm.settings.showOnlySelectedField || false;
  vm.isValid = true;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (!vm.isMultiSelect) {
      vm.isValid = newData != null;
    }
    if (newData !== oldData) {
      if (vm.isMultiSelect) {
        if (!vm.deletedOrDisabled) {
          vm.deletedOrDisabled = [];
        }
        _.set(dataService.data.activeItem, dataLookUp, vm.deletedOrDisabled.concat(newData));
      } else {
        _.set(dataService.data.activeItem, dataLookUp, newData);
      }      
    }

  });

  function refreshData(userSearch) {
    let optionalParameters = {
      isMultiSelect: vm.isMultiSelect,
      includeDisabled: vm.includeDisabled,
      filterUsingEnabled: vm.filterUsingEnabled,
      queryOption: vm.queryOption,
      selectProperty: vm.selectProperty
    };

    if (userSearch === "" && vm.settings.searchAllNo === true) {
      dataService.search(vm.settings.endpoint, vm.data, vm.settings.entityIdentifier, null, optionalParameters)
      .then((data) => {
        if (vm.isMultiSelect) {
          if (!vm.data) {
            vm.data = [];
          }

          let dataToShow = vm.data.filter(id => !!data.find(result => getPropertyValue(result, vm.entityIdentifier) === id) || vm.additionalOptions.find(option => getPropertyValue(option, vm.entityIdentifier) === id));

          if (vm.settings.includeOptions) {  
            if (vm.includeOptionsPropertyToSave != null && vm.includeOptionsPropertyToSave != undefined &&
              vm.dataSelectPropertyToCheck != null && vm.dataSelectPropertyToCheck != undefined) {
  
              vm.includeOptions.forEach((option) => { 
                var existingIncludeOption = vm.data.find(data => 
                  getPropertyValue(data, vm.dataSelectPropertyToCheck) ===
                  getPropertyValue(option, vm.includeOptionsPropertyToSave));

                  if (existingIncludeOption) {
                      dataToShow.push(existingIncludeOption);
                      data.push(option);
                  }
              });
            }
          }

          if (!vm.deletedOrDisabled) {
            vm.deletedOrDisabled = vm.data.filter(id => !dataToShow.find(result => result === id));
          }

          vm.data = dataToShow;
        }

        data = applyAdditionalFilters(data);
        data = addAdditionalOptions(data);

        vm.searchResults = data;
      })
      .catch(() => {

      });
      return;
    }

    dataService.search(vm.settings.endpoint, userSearch, vm.settings.searchType, vm.settings.expression, optionalParameters)
      .then((data) => {
        data = applyAdditionalFilters(data);
        data = addAdditionalOptions(data);

        vm.searchResults = data;

        if (vm.settings.includeOptions) {
          vm.settings.includeOptions.forEach((option) => {
            if (option.Title.toLowerCase().includes(userSearch.toLowerCase()) || 
              option.TitleInSearch.toLowerCase().includes(userSearch.toLowerCase())) {
              var newOption = vm.settings.includeOptions;
              vm.searchResults = vm.searchResults.concat(newOption);
            }
          });
        }
      })
      .catch(() => {

      });
    }

    function applyAdditionalFilters(data) {
      if (vm.settings.additionalFilters) {
        var additionalFilters = Object.keys(vm.settings.additionalFilters);

        additionalFilters.forEach((additionalFilter) => {
          data = data.filter((d) => {
            return d === null || typeof d !== 'object' || d[additionalFilter] == vm.settings.additionalFilters[additionalFilter];
          })
        });
      }
    
      return data;
    }

    function addAdditionalOptions(data) {
      if (vm.additionalOptions) {
        var additionalOptions = Object.keys(vm.additionalOptions);

        additionalOptions.forEach((additionalOption) => {
          let existingOption = data.find(option => getPropertyValue(option, vm.entityIdentifier) === getPropertyValue(vm.additionalOptions[additionalOption], vm.entityIdentifier));

          if (!existingOption) {
            data.push(vm.additionalOptions[additionalOption]);
          }
        });
      }

      return data;
    }

    function getChoiceValue(item) {
      if (item === null || typeof item !== 'object') {
        return item;
      }

      let property = item.IsIncludeOption ? vm.includeOptionsPropertyToSave : vm.entityIdentifier;
      return item[property];
    }

    function getPropertyValue(item, property) {
      if (item === null || typeof item !== 'object' || property === '') {
        return item;
      }

      return item[property];
    }
};

lbaODataSelectCtrl.$inject = $inject;

export default lbaODataSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaODataSelect/lbaODataSelectCtrl.js